// components/canvas-toolbar/useCanvasTools.ts
import { EraserBrush } from '@erase2d/fabric'
import { Canvas, PencilBrush } from 'fabric'
import { useEffect, useState } from 'react'

export type ToolType = 'pointer' | 'draw' | 'erase' | null

export function useCanvasTools(canvas: Canvas | null, objectColor: string, saveState?: () => void) {
  const [activeTool, setActiveTool] = useState<ToolType>(null)

  const handleToolSelect = (tool: ToolType) => {
    setActiveTool((prev) => (prev === tool ? null : tool))
  }

  function applyTool() {
    if (!canvas) return

    switch (activeTool) {
      case 'pointer': {
        canvas.isDrawingMode = false
        canvas.selection = true
        break
      }
      case 'draw': {
        canvas.isDrawingMode = true
        canvas.selection = false
        const pencil = new PencilBrush(canvas)
        pencil.color = objectColor
        pencil.width = 3
        canvas.freeDrawingBrush = pencil
        break
      }
      case 'erase': {
        canvas.isDrawingMode = true
        canvas.selection = false
        const eraser = new EraserBrush(canvas)
        eraser.width = 20
        canvas.freeDrawingBrush = eraser

        if (saveState) {
          eraser.on &&
            eraser.on('end', () => {
              saveState()
            })
        }

        break
      }
      default: {
        canvas.isDrawingMode = false
        canvas.selection = false
        break
      }
    }
  }

  useEffect(() => {
    if (canvas?.isDrawingMode && canvas.freeDrawingBrush instanceof PencilBrush) {
      canvas.freeDrawingBrush.color = objectColor
    }
  }, [objectColor, canvas])

  return {
    activeTool,
    setActiveTool,
    handleToolSelect,
    applyTool
  }
}
